var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWheels(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.875 0.5C24.3666 0.5 31.25 7.38339 31.25 15.875C31.25 24.3666 24.3666 31.25 15.875 31.25C7.38339 31.25 0.5 24.3666 0.5 15.875C0.5 7.38339 7.38339 0.5 15.875 0.5ZM9.725 17.4125L3.67032 17.414C4.01287 20.1234 5.24693 22.6419 7.17815 24.5729C9.10938 26.5038 11.628 27.7375 14.3375 28.0797V22.025C13.1142 22.025 11.941 21.539 11.076 20.674C10.211 19.809 9.725 18.6358 9.725 17.4125ZM28.0797 17.414L22.025 17.4125C22.025 18.6358 21.539 19.809 20.674 20.674C19.809 21.539 18.6358 22.025 17.4125 22.025L17.414 28.0797C20.1232 27.7372 22.6415 26.5034 24.5724 24.5724C26.5034 22.6415 27.7372 20.1232 28.0797 17.414ZM15.875 3.575C12.879 3.57505 9.98602 4.66845 7.73894 6.65001C5.49185 8.63156 4.04515 11.3651 3.67032 14.3375H9.725C9.725 13.9297 9.88699 13.5387 10.1753 13.2503C10.4637 12.962 10.8547 12.8 11.2625 12.8H20.4875C20.8953 12.8 21.2863 12.962 21.5747 13.2503C21.863 13.5387 22.025 13.9297 22.025 14.3375H28.0797C27.7048 11.3651 26.2581 8.63156 24.0111 6.65001C21.764 4.66845 18.871 3.57505 15.875 3.575Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWheels);
export default __webpack_public_path__ + "static/media/wheels.8b646bbf434ec1248e4f6f177be14708.svg";
export { ForwardRef as ReactComponent };